import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="subscription-plans"
export default class extends Controller {
  static targets = ["slider", "currentQuantity", "totalPriceDisplay", "hiddenQuantity", "leadLabel"]
  static outlets = ["subscription-form"]
  static values = { 
    planId: String,
    leads: { type: Number, default: 30 },
    planDescription: { type: String, default: "" },
    planDisplayName: { type: String, default: "" },
    pricePerBundle: { type: Number, default: 0 },
    minLeads: { type: Number, default: 10 },
    maxLeads: { type: Number, default: 100 }
  }

  connect() {
    // Initialize with default values if slider exists
    if (this.hasSliderTarget) {
      this.updateTotals(parseInt(this.sliderTarget.value))
      // Highlight the default selected lead count
      this.highlightSelectedLeadCount(parseInt(this.sliderTarget.value))
    }
  }
  
  openModal(event) {
    event.preventDefault()
    
    // Get the plan id and metadata from values
    const planId = this.planIdValue
    const planDescription = this.planDescriptionValue
    const planDisplayName = this.planDisplayNameValue
    const pricePerBundle = this.pricePerBundleValue
    
    // Get the actual lead count from the hidden input field
    const hiddenInputSelector = `#${planId}_leads`
    const hiddenInput = document.querySelector(hiddenInputSelector)
    const leads = hiddenInput ? parseInt(hiddenInput.value, 10) : this.leadsValue
    
    // Use the subscription form outlet to open the modal with the plan details
    if (this.hasSubscriptionFormOutlet) {
      // Call the openModal method on the controller instance
      this.subscriptionFormOutlet.openModal({
        planId,
        leads,
        planDescription,
        planDisplayName,
        pricePerBundle
      })
    } else {
      console.error("Subscription form outlet not found")
    }
  }
  
  updateFromSlider(event) {
    const leadCount = parseInt(event.currentTarget.value)
    this.updateTotals(leadCount)
    
    // Update the current quantity display
    if (this.hasCurrentQuantityTarget) {
      this.currentQuantityTarget.textContent = `${leadCount} leads`
    }
    
    // Highlight the selected lead count
    this.highlightSelectedLeadCount(leadCount)
  }

  updateTotals(leadCount) {
    // Calculate bundles needed (each bundle is 10 leads)
    const bundleSize = 10;
    const bundleQuantity = Math.ceil(leadCount / bundleSize);
    
    // Calculate the total monthly price based on bundle quantity and price per bundle
    const totalPrice = bundleQuantity * this.pricePerBundleValue;
    
    // Update the main price display at the top of the card
    if (this.hasTotalPriceDisplayTarget) {
      this.totalPriceDisplayTarget.textContent = totalPrice
    }
    
    // Update the hidden field with the actual lead count
    if (this.hasHiddenQuantityTarget) {
      this.hiddenQuantityTarget.value = leadCount
    }
  }
  
  highlightSelectedLeadCount(leadCount) {
    // Only proceed if we have lead label targets
    if (!this.hasLeadLabelTarget) return
    
    // Remove highlight from all lead labels
    this.leadLabelTargets.forEach(label => {
      label.classList.remove("text-indigo-600", "font-medium")
      label.classList.add("text-gray-500")
    })
    
    // Find and highlight the label matching the selected lead count
    const selectedLabel = this.leadLabelTargets.find(label => 
      parseInt(label.dataset.value) === leadCount
    )
    
    if (selectedLabel) {
      selectedLabel.classList.remove("text-gray-500")
      selectedLabel.classList.add("text-indigo-600", "font-medium")
    }
  }
}
